import { render, staticRenderFns } from "./CompanyAddress.vue?vue&type=template&id=0764b759&scoped=true"
import script from "./CompanyAddress.vue?vue&type=script&lang=js"
export * from "./CompanyAddress.vue?vue&type=script&lang=js"
import style0 from "./CompanyAddress.vue?vue&type=style&index=0&id=0764b759&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0764b759",
  null
  
)

export default component.exports